"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jquery_1 = __importDefault(require("jquery"));
class Maypage {
    constructor() {
        (0, jquery_1.default)(function () {
            // ラジオボタンがクリックされたときのイベントハンドラ
            (0, jquery_1.default)('input[name="select"]').on("change", function () {
                // #select1 が選択された場合
                if ((0, jquery_1.default)("#select1").is(":checked")) {
                    (0, jquery_1.default)(".mypagePremium__select-item")
                        .eq(0)
                        .find(".c-btn")
                        .prop("disabled", false);
                    (0, jquery_1.default)(".mypagePremium__select-item")
                        .eq(1)
                        .find(".c-btn")
                        .prop("disabled", true);
                }
                // #select2 が選択された場合
                else if ((0, jquery_1.default)("#select2").is(":checked")) {
                    (0, jquery_1.default)(".mypagePremium__select-item")
                        .eq(0)
                        .find(".c-btn")
                        .prop("disabled", true);
                    (0, jquery_1.default)(".mypagePremium__select-item")
                        .eq(1)
                        .find(".c-btn")
                        .prop("disabled", false);
                }
            });
        });
        //現在のポイント
        const mypointDom = document.getElementById("mypoint");
        //int型に変換ない場合は0を代入
        const mypoint = mypointDom && mypointDom.textContent !== null
            ? parseInt(mypointDom.textContent)
            : 0;
        const point_buy_form = document.getElementById("form-point-to-premium");
        //サブミット時のイベントハンドラ
        point_buy_form &&
            point_buy_form.addEventListener("submit", function (e) {
                //現在のポイントが100以上の場合
                if (mypoint < 1000) {
                    alert("ポイントが足りません");
                    e.preventDefault();
                }
                else {
                    if (!confirm("1000PT使用して購入しますか？")) {
                        e.preventDefault();
                    }
                }
            });
        (0, jquery_1.default)('input[name="point"]').change(function () {
            const selectedValue = (0, jquery_1.default)(this).val();
            (0, jquery_1.default)('#credit-form input[name="money"], #bank-form input[name="money"]').val(selectedValue);
            // ボタンを有効化
            (0, jquery_1.default)('#credit-form button[type="submit"], #bank-form button[type="submit"]').prop("disabled", false);
        });
        this.speed_order();
    }
    speed_order() {
        const form = document.getElementById("credit-form");
        const credit_url = "https://secure.telecomcredit.co.jp/inetcredit/secure/order.pl";
        const oneclick_url = "https://secure.telecomcredit.co.jp/inetcredit/secure/one-click-order.pl";
        const updateFormAction = (isChecked) => {
            if (!form)
                return;
            form.action = isChecked ? oneclick_url : credit_url;
        };
        const is_speed_order = document.getElementById("is_speed_order");
        //変更時
        is_speed_order &&
            is_speed_order.addEventListener("change", function () {
                const usrtelInput = document.getElementById("is_speed_order_usrtel");
                if (!usrtelInput)
                    return;
                if (this.checked) {
                    usrtelInput.disabled = false;
                    updateFormAction(true);
                }
                else {
                    usrtelInput.disabled = true;
                    updateFormAction(false);
                }
            });
        if (is_speed_order) {
            updateFormAction(is_speed_order.checked);
        }
    }
}
exports.default = Maypage;
new Maypage();
